import React, { Component } from "react";

export default class AirlineInfo extends Component {
	outputMessage() {
		switch (this.props.airline) {
			case "latam":
				return (
					<p>
						<strong>Sobre bagagem despachada:</strong> A <strong>LATAM</strong> alterou suas regras
						e passou a cobrar por bagagem despachada. Para acrescentar esse serviço à sua passagem,
						basta prosseguir a sua compra com a gente.
					</p>
				);

			case "gol":
				return (
					<p>
						<strong>Sobre bagagem despachada:</strong> A <strong>GOL</strong> alterou suas regras e
						passou a cobrar por bagagem despachada. Para acrescentar esse serviço à sua passagem,
						consulte a companhia aérea com o código localizador (enviado por e-mail) após finalizar
						sua compra.{" "}
					</p>
				);

			case "avianca":
				return (
					<p>
						<strong>Sobre bagagem despachada:</strong> Pela <strong>AVIANCA</strong>, você já tem 1
						bagagem inclusa (até 23kg) por passageiro. Para adicionar mais, consulte a companhia
						aérea com o código localizador (enviado por e-mail) após finalizar sua compra.
					</p>
				);

			case "azul":
				return (
					<p>
						Informamos que a <strong>Azul</strong> cobra por bagagem despachada. Para isso é preciso
						pagar, por passageiro, R$50,00 na bagagem de até 23kg, tanto na Ida quanto na volta.
					</p>
				);

			default:
				return null;
		}
	}

	render() {
		if (this.outputMessage() !== null) {
			return (
				<div className="alert alert-info" role="alert">
					<div className="alert--icon">
						<i className="icon-exclamation" />
					</div>
					<div className="alert--message">{this.outputMessage()}</div>
				</div>
			);
		}

		return null;
	}
}
